(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jungle-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jungle-precheckout')) {
    customElements.define('jungle-precheckout', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.busy = false;
        this.pending = null;
        this.returnFocus = null;
        this.cartUrl = this.dataset.cartUrl;
        const inline = this.querySelector('[data-jungle-recommendations]');
        const checkout = document.querySelector('form[data-cart-form] .cart-checkout');
        if (inline && checkout && this.nextElementSibling !== checkout) requestAnimationFrame(() => {if(this.isConnected) checkout.before(this);});
        this.clickHandler = event => {
          const add = event.target.closest('[data-jungle-add]');
          if (add && (this.contains(add) || this.dialog?.contains(add))) {
            event.preventDefault();
            this.addProduct(add);
            return;
          }
          const control = event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
          if (!control || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (control.matches('a')) {
            const url = new URL(control.href, location.origin);
            if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkouts?(?:\/|$)/i.test(url.pathname)) return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          this.returnFocus = control;
          this.offer({form:control.form || null, control:control.matches('a') ? null : control, href:control.matches('a') ? control.href : null});
        };
        this.submitHandler = event => {
          const form = event.target;
          if (!form.matches('form') || form.dataset.jungleProceed === 'true' || event.defaultPrevented) return;
          const submitter = event.submitter;
          if (submitter?.name !== 'checkout' && !/\/checkout\/?$/.test(new URL(form.action).pathname)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.returnFocus = submitter;
          this.offer({form,control:submitter || null,href:null});
        };
        this.changeHandler = event => {
          const select = event.target.closest('select[data-jungle-variant]');
          if (!select) return;
          const card = select.closest('[data-jungle-card]');
          const button = card.querySelector('[data-jungle-add]');
          if (button.dataset.added !== 'true' && select.value) {
            button.disabled = false;
            button.textContent = button.dataset.addLabel;
            button.setAttribute('aria-label',button.dataset.addAriaLabel);
          }
          card.querySelector('[data-jungle-price]').textContent = select.selectedOptions[0]?.dataset.price || '';
          const selectedImage=select.selectedOptions[0]?.dataset.image;
          const image=card.querySelector('.jungle-cart-addons__image img');
          if(selectedImage && image) {image.src=selectedImage;image.removeAttribute('srcset');}
          if (select.value) card.querySelectorAll('a').forEach(link => {const url=new URL(link.href);url.searchParams.set('variant',select.value);link.href=url.toString();});
        };
        document.addEventListener('click',this.clickHandler,true);
        document.addEventListener('submit',this.submitHandler,true);
        document.addEventListener('change',this.changeHandler);
      }
      async readCart() {
        const response = await fetch(`${this.cartUrl}.js`,{headers:{Accept:'application/json'},cache:'no-store',signal:AbortSignal.timeout(5000)});
        if (!response.ok) throw new Error('cart');
        return response.json();
      }
      formatMoney(amount) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:this.dataset.currency || 'IDR',maximumFractionDigits:this.dataset.currency === 'IDR' ? 0 : 2}).format(amount / 100);
      }
      updateTotals(cart) {
        document.querySelectorAll('[data-cart-total],[data-atc-banner-cart-subtotal]').forEach(node => {node.textContent=this.formatMoney(cart.total_price);});
        document.querySelectorAll('[data-cart-count]').forEach(node => {node.textContent=cart.item_count;});
        document.querySelectorAll('[data-header-cart-count]').forEach(node => {node.dataset.headerCartCount=cart.item_count;node.classList.toggle('visible',cart.item_count>0);});
        document.querySelectorAll('[data-atc-banner-cart-button] span').forEach(node => {node.textContent=cart.item_count;});
        if (this.subtotal) this.subtotal.textContent=`${this.dataset.subtotal}: ${this.formatMoney(cart.total_price)}`;
      }
      async offer(target) {
        if (this.busy) return;
        if (this.dialog?.open) return;
        this.busy = true;
        this.pending = target;
        target.control?.setAttribute('aria-busy','true');
        try {
          const url = new URL(this.cartUrl,location.origin);
          url.searchParams.set('section_id','static-cart');
          const [cart,response] = await Promise.all([this.readCart(),fetch(url,{cache:'no-store',signal:AbortSignal.timeout(5000)})]);
          if (!response.ok || !cart.item_count) throw new Error('recommendations');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const recommendations = html.querySelector('[data-jungle-recommendations] .jungle-cart-addons');
          if (!recommendations?.querySelector('[data-jungle-card]')) {this.proceed();return;}
          this.openDialog(recommendations,cart);
        } catch {this.proceed();}
        finally {target.control?.removeAttribute('aria-busy');this.busy=false;}
      }
      openDialog(recommendations,cart) {
        this.dialog?.remove();
        const dialog = document.createElement('dialog');
        dialog.className='jungle-precheckout-dialog';
        dialog.setAttribute('aria-labelledby','jungle-precheckout-title');
        const close = document.createElement('button');
        close.type='button';close.className='jungle-precheckout-dialog__close';close.setAttribute('aria-label',this.dataset.close);close.textContent='×';
        close.addEventListener('click',()=>dialog.close());
        recommendations.querySelector('[data-jungle-heading]').id='jungle-precheckout-title';
        const footer=document.createElement('div');footer.className='jungle-precheckout-dialog__footer';
        this.subtotal=document.createElement('p');this.subtotal.className='jungle-precheckout-dialog__subtotal';this.subtotal.setAttribute('aria-live','polite');
        this.continueButton=document.createElement('button');this.continueButton.type='button';this.continueButton.className='jungle-precheckout-dialog__continue';this.continueButton.textContent=this.dataset.continue;
        this.continueButton.addEventListener('click',()=>{if (!this.busy) this.proceed();});
        footer.append(this.subtotal,this.continueButton);dialog.append(close,recommendations,footer);document.body.append(dialog);this.dialog=dialog;
        this.updateTotals(cart);
        dialog.addEventListener('close',()=>{if (this.inlineDirty) {location.assign(this.cartUrl);return;} this.returnFocus?.focus();});
        dialog.addEventListener('cancel',event=>{if(this.busy) event.preventDefault();});
        dialog.showModal();
        this.continueButton.focus();
      }
      async addProduct(button) {
        if (button.disabled || this.busy) return;
        const card=button.closest('[data-jungle-card]');
        const variant=card.querySelector('[data-jungle-variant]');
        if (!variant?.value) {variant?.focus();try {variant?.showPicker?.();} catch {} return;}
        this.busy=true;button.disabled=true;
        const label=button.textContent;button.textContent=this.dataset.adding;
        const message=card.querySelector('[data-jungle-message]');message.textContent='';
        if(this.continueButton) this.continueButton.disabled=true;
        try {
          const response=await fetch(`${this.dataset.addUrl}.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(variant.value),quantity:1}]})});
          const result=await response.json();
          if(!response.ok) throw new Error(result.description || this.dataset.error);
          button.dataset.added='true';button.textContent=this.dataset.added;variant.disabled=true;message.textContent=this.dataset.added;
          if(!this.dialog?.contains(button)) {location.assign(this.cartUrl);return;}
          this.inlineDirty=document.body.classList.contains('template-cart');
          try {this.updateTotals(await this.readCart());} catch {if(this.subtotal) this.subtotal.textContent='';}
          this.querySelectorAll('[data-jungle-card]').forEach(other=>{if(other.dataset.productId===card.dataset.productId) other.remove();});
        } catch(error) {button.disabled=false;button.textContent=label;message.textContent=error.message || this.dataset.error;}
        finally {this.busy=false;if(this.continueButton) this.continueButton.disabled=false;}
      }
      proceed() {
        const target=this.pending;this.pending=null;
        if(!target) return;
        if(target.href) {location.assign(target.href);return;}
        if(target.form?.isConnected) {
          target.form.dataset.jungleProceed='true';
          if(target.control?.isConnected) target.form.requestSubmit(target.control);
          else target.form.requestSubmit();
          delete target.form.dataset.jungleProceed;
          return;
        }
        location.assign(this.cartUrl.replace(/\/cart\/?$/, '/checkout'));
      }
      disconnectedCallback() {
        document.removeEventListener('click',this.clickHandler,true);
        document.removeEventListener('submit',this.submitHandler,true);
        document.removeEventListener('change',this.changeHandler);
        this.dialog?.remove();this.initialized=false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jungle-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jungle-delivery')) {
    customElements.define('jungle-delivery', class extends HTMLElement {
      connectedCallback() {
        this.labels = JSON.parse(this.querySelector('[data-jungle-labels]').textContent);
        this.minimum = Number(this.dataset.minimum);
        this.total = Number(this.dataset.total);
        this.region = this.querySelector('[data-jungle-region]');
        this.update = () => {
          const outside = this.region.value === 'other';
          const remaining = Math.max(0, this.minimum - this.total);
          const amount = new Intl.NumberFormat('id-ID', {style:'currency', currency:'IDR', maximumFractionDigits:0}).format(remaining / 100);
          const label = outside ? this.labels.outside : remaining === 0 ? (this.region.value === 'bali' ? this.labels.qualified : this.labels.conditionalQualified) : (this.region.value === 'bali' ? this.labels.remaining : this.labels.conditional);
          this.querySelector('[data-jungle-delivery-status]').textContent = label.replace('__amount__', amount);
          const progress = this.querySelector('progress');
          progress.value = Math.min(this.total, this.minimum);
          progress.hidden = outside;
          this.querySelector('[data-jungle-quote]').hidden = outside || remaining === 0;
        };
        this.region.addEventListener('change', this.update);
        this.registerIntegration = () => {
          if (!window.api?.integrations?.register || !this.isConnected) return;
          window.api.integrations.register({
            id:'Jungle Surf Bali Delivery',
            contact:'junglesurf@junglesurfworld.com',
            events:{'cart:updated':() => { if (this.isConnected) return this.refreshRecommendations(); }}
          });
        };
        this.registerIntegration();
        document.addEventListener('DOMContentLoaded', this.registerIntegration, {once:true});
        const form = this.closest('[data-cart-form]');
        this.totalElement = form?.querySelector('[data-cart-total]');
        this.sync = () => {
          const displayedTotal = this.totalElement.getAttribute('data-cart-total');
          if (displayedTotal === this.lastDisplayedTotal) return;
          this.lastDisplayedTotal = displayedTotal;
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refreshRecommendations(), 200);
        };
        if (this.totalElement) {
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(this.totalElement, {attributes:true, attributeFilter:['data-cart-total']});
          this.sync();
        }
        this.country = form?.querySelector('#address_country');
        this.province = form?.querySelector('#address_province');
        this.destinationChange = () => {
          if (this.country?.value && this.country.value !== 'Indonesia') this.region.value = 'other';
          else if (this.province?.value) this.region.value = this.province.value === 'Bali' ? 'bali' : 'other';
          this.update();
        };
        this.country?.addEventListener('change', this.destinationChange);
        this.province?.addEventListener('change', this.destinationChange);
        this.update();
      }
      async refreshRecommendations() {
        this.request?.abort();
        this.request = new AbortController();
        try {
          const url = new URL(this.dataset.cartUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {signal:this.request.signal});
          if (!response.ok || !this.isConnected) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const delivery = html.querySelector('jungle-delivery');
          const total = Number(delivery?.dataset.total);
          if (delivery && Number.isFinite(total)) { this.total = total; this.update(); }
          const next = html.querySelector('[data-jungle-recommendations]');
          const current = this.closest('.shopify-section')?.querySelector('[data-jungle-recommendations]');
          if (next && current) current.replaceChildren(...next.childNodes);
        } catch (error) {
          if (error.name !== 'AbortError') return;
        }
      }
      disconnectedCallback() {
        this.region?.removeEventListener('change', this.update);
        this.country?.removeEventListener('change', this.destinationChange);
        this.province?.removeEventListener('change', this.destinationChange);
        document.removeEventListener('DOMContentLoaded', this.registerIntegration);
        this.observer?.disconnect();
        this.request?.abort();
        clearTimeout(this.refreshTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jungle-distributor-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const expires = Date.parse('2027-01-01T00:00:00+08:00');
    const expire = () => {
      if (Date.now() >= expires) {
        document.querySelectorAll('[data-jungle-year-end-offer]').forEach(element => element.remove());
        return true;
      }
      return false;
    };
    if (!expire()) {
      const timer = setInterval(() => { if (expire()) clearInterval(timer); }, 60000);
      document.addEventListener('visibilitychange', expire);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jungle-mobile-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jungle-mobile-cart')) {
    customElements.define('jungle-mobile-cart', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section');
        this.form = this.root?.querySelector('form[data-product-form]');
        this.source = this.form?.querySelector('[data-product-atc]');
        if (!this.source) return;
        this.button = this.querySelector('[data-jungle-add]');
        this.visibility = () => { this.hidden = this.source.getBoundingClientRect().bottom > 0 || this.source.getClientRects().length === 0; };
        window.addEventListener('scroll', this.visibility, {passive:true});
        window.addEventListener('resize', this.visibility);
        const mobileNav = document.getElementById('mobile-bar');
        if (mobileNav) {
          this.navObserver = new ResizeObserver(() => this.style.setProperty('--jungle-mobile-nav-height', `${mobileNav.getBoundingClientRect().height}px`));
          this.navObserver.observe(mobileNav);
        }
        this.update = () => {
          const options = [...this.form.querySelectorAll('select[data-product-option], input[data-product-option]:checked')].map(input => input.value);
          this.querySelector('[data-jungle-options]').textContent = options.join(' / ');
          const price = this.root.querySelector('.product-pricing [data-price] .money');
          if (price) this.querySelector('[data-jungle-price]').textContent = price.textContent.trim();
          const quantity = this.form.querySelector('[name="quantity"]')?.value || '1';
          this.querySelector('[data-jungle-quantity]').textContent = `${this.dataset.quantityLabel}: ${quantity}`;
          const label = this.source.querySelector('.atc-button--text')?.textContent.trim();
          if (label) this.button.textContent = label;
          this.button.disabled = this.source.disabled || this.source.classList.contains('disabled') || this.source.classList.contains('processing');
          this.visibility();
        };
        this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); };
        this.form.addEventListener('change', this.schedule);
        this.form.addEventListener('input', this.schedule);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.source, {attributes:true, childList:true, subtree:true, characterData:true});
        const pricing = this.root.querySelector('.product-pricing');
        if (pricing) this.observer.observe(pricing, {childList:true, subtree:true, characterData:true});
        this.intersection = new IntersectionObserver(this.visibility);
        this.intersection.observe(this.source);
        this.querySelector('[data-jungle-change]').addEventListener('click', () => {
          this.form.scrollIntoView({block:'center'});
          this.form.querySelector('select[data-product-option], input[data-product-option], [data-product-atc]')?.focus({preventScroll:true});
        });
        this.button.addEventListener('click', () => {
          this.update();
          if (!this.button.disabled) {
            if (this.form.checkValidity()) this.source.click();
            else { this.form.scrollIntoView({block:'center'}); this.form.reportValidity(); }
          }
        });
        this.update();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change', this.schedule);
        this.form?.removeEventListener('input', this.schedule);
        this.observer?.disconnect();
        this.intersection?.disconnect();
        this.navObserver?.disconnect();
        window.removeEventListener('scroll', this.visibility);
        window.removeEventListener('resize', this.visibility);
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jungle-shopping-tools"] && !Shopify.designMode) return;
  try {
    (()=>{
    function init(){
      document.querySelectorAll('[data-jungle-filter-form]').forEach(form=>{
        if(form.dataset.jungleReady)return;
        form.dataset.jungleReady='true';
        form.addEventListener('submit',event=>{
          event.preventDefault();
          const url=new URL(window.location.href);
          [...url.searchParams.keys()].forEach(key=>{if(key.startsWith('filter.')||key==='page'||key==='sort_by')url.searchParams.delete(key)});
          for(const [key,value] of new FormData(form)){if(String(value).trim()!=='')url.searchParams.append(key,String(value))}
          window.location.assign(url.href);
        });
      });
      document.querySelectorAll('[data-jungle-preserve-filters]').forEach(link=>{
        const target=new URL(link.href);
        const current=new URL(window.location.href);
        current.searchParams.forEach((value,key)=>{if(key.startsWith('filter.')||key==='sort_by')target.searchParams.set(key,value)});
        link.href=target.href;
      });
      document.querySelectorAll('[data-jungle-buying-info]').forEach(info=>{
        if(info.dataset.jungleReady)return;
        info.dataset.jungleReady='true';
        const data=JSON.parse(info.querySelector('[data-jungle-variant-stock]').textContent);
        const article=info.closest('article')||info.parentElement;
        const form=article.querySelector('form[action*="/cart/add"]');
        const stock=info.querySelector('[data-jungle-stock]');
        if(!form)return;
        function update(){
          const id=form.querySelector('[name="id"]')?.value;
          const variant=data.variants[id];
          stock.hidden=!variant;
          if(!variant)return;
          stock.textContent=data.labels[variant.available?(variant.in_stock?'in_stock':'available'):'unavailable'];
          stock.toggleAttribute('data-unavailable',!variant.available);
        }
        form.addEventListener('change',()=>{requestAnimationFrame(update);setTimeout(update,150)});
        update();
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    document.addEventListener('shopify:section:load',init);
  })();
  } catch(e) { console.error(e); }
})();

})();
